<template>
  <div class="container-fluid">
    <h2 class="title-1">Хэрэглэгчид</h2>
    <div class="mt-3">
      <div class="row">
        <div class="col-11">
          <div class="form-row">
            <div class="col">
              <input
                v-model="cardNumber"
                class="form-control"
                type="text"
                maxlength="16"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                placeholder="Картын дугаар"
              >
            </div>
            <div class="col">
              <input
                v-model="phone"
                type="text"
                class="form-control"
                maxlength="8"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                placeholder="Утас"
              >
            </div>
            <div class="col">
              <input v-model="email" type="text" class="form-control" placeholder="И-Мэйл">
            </div>
            <div class="col">
              <input v-model="registerId" type="text" class="form-control" placeholder="Регистр">
            </div>
          </div>
        </div>
        <button @click="search();" class="btn btn-primary">Хайх</button>
      </div>
    </div>

    <div v-if="users !== null" class="card w-100 mt-3">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-top-campaign">
            <tbody>
              <tr v-for="(user, i) in users" :key="i">
                <td>{{ user.id }}</td>
                <td>
                  {{ user.firstName }}
                  <br>
                  {{ user.lastName }}
                </td>
                <td>
                  {{ user.birthdate }}
                  <br>
                  {{ user.registerId }}
                </td>
                <td>
                  {{ user.sex == 0 ? "Эр" : "Эм" }}
                  <br>
                  {{ user.country }}
                </td>
                <td>
                  {{ user.email }}
                  <br>
                  {{ user.phone }}
                </td>
                <td>
                  {{ user.status == 1 ? "Идэвхитэй" : "Блоклогдсон" }}
                  <br>
                  <div v-if="isSuperAdmin">
                    <button
                      @click="changeStatus(user)"
                      v-if="user.status != 1"
                      class="btn btn-warning btn-sm"
                    >Идэвхжүүлэх</button>
                    <button
                      @click="changeStatus(user)"
                      v-if="user.status == 1"
                      class="btn btn-info btn-sm"
                    >Блоклох</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="this.totalPages > 1" class="pagination-container">
        <paginate
          :page-count="totalPages"
          :container-class="'pagination'"
          :prev-text="'<'"
          :next-text="'>'"
          :click-handler="onPageClick"
        >
          <span slot="breakViewContent">
            <svg width="16" height="4" viewBox="0 0 16 4">
              <circle fill="#999999" cx="2" cy="2" r="2"></circle>
              <circle fill="#999999" cx="8" cy="2" r="2"></circle>
              <circle fill="#999999" cx="14" cy="2" r="2"></circle>
            </svg>
          </span>
        </paginate>
      </div>
    </div>
  </div>
</template>
<style>
.pagination-container {
  text-align: center;
}
.pagination {
  display: inline-block;
  padding-left: 0;
  margin: 20px 0;
  border-radius: 4px;
}
.pagination > li {
  display: inline;
}
.pagination > li > a,
.pagination > li > span {
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
}
.pagination > li.active > a {
  background-color: #8395d1 !important;
}
</style>

<script>
import UserService from "@/services/UserService";

export default {
  name: "UsersList",

  created() {
    this.getUsers();
  },

  computed: {
    isSuperAdmin: function() {
      return this.$store.getters.loggedAdmin.role == 0;
    }
  },

  data() {
    return {
      users: null,
      cardNumber: null,
      phone: null,
      email: null,
      registerId: null,

      pageNum: 1,
      totalPages: 0
    };
  },

  methods: {
    getUsers() {
      this.$store.dispatch("setLoading", true);
      const data = JSON.parse("{}");
      data.card = this.cardNumber == "" ? null : this.cardNumber;
      data.phone = this.phone == "" ? null : this.phone;
      data.email = this.email == "" ? null : this.email;
      data.registerId = this.registerId == "" ? null : this.registerId;
      UserService.getUsersList({}, data, this.pageNum).then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.totalPages = response.data.payload.totalPages;
          this.users = response.data.payload.rows;
        }

        this.$store.dispatch("setLoading", false);
      });
    },

    search() {
      this.pageNum = 1;
      this.getUsers();
    },

    changeStatus(user) {
      this.$store.dispatch("setLoading", true);
      let data = JSON.parse("{}");
      data.id = user.id;
      if (user.status == 1) data.status = 2;
      else data.status = 1;

      UserService.changeStatus({}, data).then(response => {
        if (response.status == 200 && response.data.success == true) {
          if (response.data.payload.toast != null)
            this.showToast(response.data.payload.toast);
          user.status = data.status;
          this.$store.dispatch("setLoading", false);
        }
      });
    },

    onPageClick(pageNum) {
      this.pageNum = pageNum;
      this.getUsers();
    }
  }
};
</script>